import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import {
  ControlContainer,
  NgForm
} from '@angular/forms';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-multiselect-control',
  styles: [ require('./multiselect-control.component.scss') ],
  template: require('./multiselect-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class MultiselectControl extends TextControlComponent {
  @Input () displayField       = '';
  @Input () items : Array<any> = [];
  @Input () modelField         = '';

  @Output() change: EventEmitter<Array<any>> = new EventEmitter();

  handleChange ( selections : Array<any> ) : void {
    this.change.emit(selections);
  }
}
